import useStore from "config/store";
import { useEffect } from "react";
import { matchPath, useLocation, useParams } from "react-router-dom";
import { ACCOUNTING_FIRM_ROUTES } from "views/AccountingFirm/utils/accountingFirmRoutes";
import { COMPANY_ROUTES } from "views/Company/utils/companyRoutes";
import { routers } from "./index";
import { RoutePermission, useRoutePermissions } from "./useRoutePermissions";

interface PermissionRedirectProps {
  children: React.ReactNode;
  requiredPermission: RoutePermission;
}

export default function PermissionRedirect({
  children,
  requiredPermission,
}: PermissionRedirectProps) {
  const userData = useStore(state => state.userData);
  const { pathname } = useLocation();
  const { companyId, accountingFirmId } = useParams();
  const routePermissions = useRoutePermissions();

  const isAccountingFirmRoute = !!matchPath(
    { path: ACCOUNTING_FIRM_ROUTES.accountingFirmDetail, end: false },
    pathname,
  );
  const isCompanyRoute = !!matchPath({ path: COMPANY_ROUTES.companyDetail, end: false }, pathname);

  let hasPermission = true;

  if (requiredPermission !== "none") {
    hasPermission = !!routePermissions[requiredPermission];
  } else if (userData && accountingFirmId && isAccountingFirmRoute) {
    // No permission to check, so fall back to whether the user belongs to the
    // entity in the URL.
    hasPermission = userData.isSuperuser || userData.accountingFirms.includes(accountingFirmId);
  } else if (userData && companyId && isCompanyRoute) {
    hasPermission = userData.isSuperuser || userData.companies.includes(companyId);
  }

  useEffect(() => {
    if (userData && !hasPermission) routers.navigate("/", { replace: true });
  }, [hasPermission, userData]);

  return <>{children}</>;
}
